module.exports = __webpack_public_path__ + "img/n-h-page2-3.c8decde3.png";